<span
  class="spinner"
  [ngClass]="{
    loading: isLoading,
    'animated-expand': isLoading
  }"
>
  <fa-icon
    class="loading-spinner spin-it"
    [icon]="['fal', 'spinner-third']"
  ></fa-icon>
</span>
